SJ.SkiJumper = class {
  constructor(x, y) {
    this.start_x = x;
    this.start_y = y;

    this.scale = SJ.V.jumperScale;

    this._w = 150 * this.scale;
    this._h = 100 * this.scale;

    this.S = {
      START: 0, // hand waving
      READY: 1, // Ready to go
      DOWN: 2, // Downhill
      FLYING: 3, // Flying
      LANDED: 5, // Landed on pad (or failed)
      END: 6, // Landed, hited end of the pad (stopped)
    };

    this.FLY_S = {
      JUMP: 0, // Jump animation, cannot start landing yet
      FLY: 1, // Static fly animation, can land
      FALLDOWN: 2, // Fly with velocity.y > 0
      LANDING: 3, // Landing animation, but not landed yet
      LANDED: 4, // Landing animation ended, ready to hit pad
    };

    this.SLOWING_SPEED = 0.01;
    this.LANDING_TIME_MILLIS = 150;

    this._setupAnimations();

    this.reset();
  }

  reset() {

    if (this.body)
      Matter.World.remove(SJ.world, this.body)

    const x = this.start_x;
    const y = this.start_y;

    const skies = Matter.Bodies.rectangle(x, y, this._w, 20, {
      chamfer: { radius: 5 },
    });
    const jBody = Matter.Bodies.rectangle(
      x,
      y - this._h / 2.5,
      this._w / 10,
      this._h * 1.2
    );

    Matter.Body.rotate(jBody, 0.6);
    Matter.Body.rotate(skies, -0.15);

    const options = {
      friction: 0.0,
      frictionAir: SJ.V.airFriction,
      density: 1,
      isStatic: true,
      parts: [
        skies,
        jBody
      ],
    };
    this.body = Matter.Body.create(options);
    Matter.World.add(SJ.world, this.body);

    this.realBodyStatic = true;

    this.state = this.S.START;

    this.flyState = this.FLY_S.JUMP;

    this.jumpForceBonus = 0;

    this.jumped = false;
    this.jumpedToEarly = false;

    this.padHit = false;

    this.isSlowingDown = false;

    this.offsetAngle = 0;

    this.turningDir = 0;
    this.turningMod = 0.0;
    this.wantTurn = false;

    this.landingTimeCounter = 0.0;
    this.canLand = true;
    this.failed = false;

    this.overRotate = false;

    this.offsetPoint = Matter.Vector.create(0, -10);

    this.c = color(255);

    this.animationPlayer.forEachAnimation((animation) => {
      animation.offset = new p5.Vector(-140, -145);
    });

    this.setAngle(this.getPadAngle());

    this.animationPlayer.play("start");
  }

  _setupAnimations() {
    const animationsFolder = "JumperAnimation/";

    this.animationPlayer = new SJ.AnimationPlayer({
      start: new SJ.AnimationSpriteSheet(animationsFolder + "1new/start alternatywny/start.png", 230, 230, 29, 2000),
      downhill: new SJ.Animation(
        [SJ.ImageLoader.load(animationsFolder + "1new/zjazd/zjazd.png")],
        1000,
        true,
        true
      ),
      jump: new SJ.AnimationSpriteSheet(animationsFolder + "1new/wybicie/wybicie.png", 230, 230, 10, 200),
      fly: new SJ.Animation(
        [SJ.ImageLoader.load(animationsFolder + "1new/lot/lot.png")],
        1000,
        true,
        true
      ),
      "rotate-right": new SJ.AnimationSpriteSheet(animationsFolder + "1new/lot/prawo/prawo.png", 230, 230, 5, 900, true),
      "rotate-left": new SJ.AnimationSpriteSheet(animationsFolder + "1new/lot/lewo/lewo.png", 230, 230, 6, 1000, true),
      land: new SJ.AnimationSpriteSheet(animationsFolder + "1new/ladowanie/ladowanie1.png", 230, 230, 5, this.LANDING_TIME_MILLIS),
      land2: new SJ.AnimationSpriteSheet(animationsFolder + "1new/ladowanie/ladowanie2.png", 230, 230, 6, this.LANDING_TIME_MILLIS),
      land_downhill: new SJ.AnimationSpriteSheet(animationsFolder + "1new/ladowanie/ladowanie3.png", 230, 230, 5, 300),
      "jump-end": new SJ.AnimationSpriteSheet(animationsFolder + "1new/dojazd/dojazd.png", 230, 230, 11, 900, true),
      "jump-end2": new SJ.AnimationSpriteSheet(animationsFolder + "1new/wiwat/wiwat.png", 230, 230, 20, 1700, true, true),
      fail_back: new SJ.AnimationSpriteSheet(animationsFolder + "1new/upadek-tyl/upadek-tyl.png", 230, 230, 26, 800),
      fail_front: new SJ.AnimationSpriteSheet(animationsFolder + "1new/upadek-przod/upadek-przod.png", 230, 230, 23, 500),
      fail_rolling: new SJ.AnimationSpriteSheet(animationsFolder + "1new/upadek-turlanie/upadek-turlanie.png", 230, 230, 24, 1300),
      fail_dangerous: new SJ.AnimationSpriteSheet(animationsFolder + "1new/upadek-dan/upadek-dan.png", 230, 230, 14, 800),
      "fail_hard": new SJ.AnimationSpriteSheet(animationsFolder + "1new/upadek-hard/upadek-hard.png", 230, 230, 26, 1300)
    });

    this.animationPlayer.onAnimationFinished((animationName) => {
      switch (animationName) {
        case "start":
          this.state = this.S.READY;
          this.animationPlayer.play("downhill");
          break;
        case "jump":
          this.animationPlayer.play("fly");
          this.flyState = this.FLY_S.FLY;
          break;
        case "rotate-right":
        case "rotate-left":
          this.animationPlayer.play("fly");
          break;
        case "land":
          this.animationPlayer.play("land2");
          break;
        case "land_downhill":
          this.animationPlayer.play("jump-end");
          break;
        case "jump-end":
          if (SJ.scoreCounter.jumpDistance > SJ.V.HSPoint * 60 / 100) {
            if (SJ.scoreCounter.jumpDistance < SJ.V.HSPoint * 85 / 100) {
              if (SJ.Tools.getRandom(0, 1) < 0.5)
                this.animationPlayer.play("jump-end2");
            }
            else
              this.animationPlayer.play("jump-end2");
          }
          break;
      }
    });
  }

  update() {

    switch (this.state) {
      case this.S.START:
        break;
      case this.S.FLYING:
        this._updateOnFly();
        break;
      case this.S.LANDED:
        this.body.velocity.x = lerp(
          this.body.velocity.x,
          0,
          this.SLOWING_SPEED
        );
        this.body.velocity.y = lerp(
          this.body.velocity.y,
          0,
          this.SLOWING_SPEED
        );

        this.setAngle(this.body.angle - 0.03);
        break;
    }

    if (this.body.isStatic) {
      Matter.Body.translate(this.body, this.body.velocity);
    } else {
      const collisionPoints = SJ.V.padCollisionPoints;
      const lastPoint = collisionPoints[collisionPoints.length - 1].x - 100;
      const { x } = this.body.position;
      if (x >= lastPoint) {
        this.body.position.x = lastPoint;
        this.body.velocity.x = 0;
      }
    }

  }

  _updateOnFly() {
    this.controlWithJoystick();
    switch (this.flyState) {
      case this.FLY_S.FLY:
      case this.FLY_S.JUMP:
      case this.FLY_S.FALLDOWN:
        if (!this.overRotate) {
          if (this.turningMod) {
            if (this.wantTurn) {
              this.turningMod = lerp(this.turningMod, 0.5, 0.02);
            } else {
              this.turningMod = lerp(this.turningMod, 0, 0.04);
            }

            this.turn();
          }

          this._checkOverRotate();
        } else {
          this.setAngle(this.getPadAngle());
        }
        break;
      case this.FLY_S.LANDING:
        this.landingTimeCounter += deltaTime;

        if (this.landingTimeCounter >= this.LANDING_TIME_MILLIS) {
          print("Land ended");
          this.flyState = this.FLY_S.LANDED;
        }
        break;
    }

    if (this.flyState == this.FLY_S.FLY) {
      if (this.body.velocity.y > 0) {
        this.flyState = this.FLY_S.FALLDOWN;
      }
    }

    if (this.padHit) {
      console.log(`-----PAD HITED-----`);
      console.log(``);
      this.onPadHit();
      this.padHit = false;
      return;
    }
  }

  onPadHit() {
    SJ.jumperSoundContainer.play("landing");
    SJ.jumperSoundContainer.stop("fly");
    this.setStatic(true);
    this.state = this.S.LANDED;

    if (!this.failed && !this.overRotate)
      this.checkIfFail();

    SJ.main.onJumperPadHit();
  }

  checkIfFail() {
    const padAngle = this.getPadAngle();

    const angle = this.getNormalizedBodyAngle();
    this.diffAngle = degrees(angle - padAngle);

    if (this.flyState == this.FLY_S.LANDED) {
      if (abs(this.diffAngle) >= SJ.V.goodLandingAngle) {
        this._fail(this.diffAngle, true);
      } else {
        this._landSuccess();
      }
    } else {
      this._fail(this.diffAngle, false);
    }

    this.setAngle(padAngle);
  }

  _fail(deg, landed) {
    if (!this.failed) {

      if (this.jumped) {
        if (deg > SJ.V.goodLandingAngle * -1 - 20 && deg <= 0) {
          this.animationPlayer.play("fail_back");

          this.animationPlayer.forEachAnimation((animation) => {
            animation.offset = new p5.Vector(-140, -200);
          });

          SJ.scoreCounter.crashPoints = 4;
        }
        else if (deg < SJ.V.goodLandingAngle + 20 && deg > 0) {
          this.animationPlayer.play("fail_front");

          this.animationPlayer.forEachAnimation((animation) => {
            animation.offset = new p5.Vector(-140, -180);
          });
          SJ.scoreCounter.crashPoints = 4;
        }
        else {
          this.animationPlayer.play("fail_rolling");

          this.animationPlayer.forEachAnimation((animation) => {
            animation.offset = new p5.Vector(-140, -200);
          });
          SJ.scoreCounter.crashPoints = 7;
        }
        SJ.jumperSoundContainer.play("lightHit");
      }
      else if (this.jumpedToEarly) {
        this.animationPlayer.play('fail_dangerous');
        SJ.jumperSoundContainer.play("havyHit");
        this.state = this.S.LANDED;
        SJ.scoreCounter.crashPoints = 7;
      }
      else if (!SJ.jumper.jumped && !SJ.jumper.jumpedToEarly) {
        this.animationPlayer.forEachAnimation((animation) => {
          animation.offset = new p5.Vector(-140, -170);
        });
        this.animationPlayer.play("fail_hard");
        SJ.jumperSoundContainer.play("hardHit");
        SJ.scoreCounter.crashPoints = 7;
      }

      SJ.crowdSoundContainer.play(random(['crowdFail1', 'crowdFail2', 'crowdFail3']));
      SJ.MessagesManager.fail();
      this.failed = true;
    }

  }

  _landSuccess() {
    this.animationPlayer.play("land_downhill");

    this.playCrowdJumpDistanceSound();

    this.animationPlayer.forEachAnimation((animation) => {
      animation.offset = new p5.Vector(-140, -145);
    });
    SJ.MessagesManager.noFail();
  }

  playCrowdJumpDistanceSound() {

    const mapDistanceBreakPoint = {
      'Szczyrk': 85,
      'Oberstdorf': 110,
      'Zakopane': 115,
      'Vikersund': 180,
      'Planica': 180,
      'Pekin': 230
    }

    if (SJ.scoreCounter.jumpDistance < mapDistanceBreakPoint[SJ.currentLocationName])
      SJ.crowdSoundContainer.play(random(['crowdShortJump1', 'crowdShortJump2', 'crowdShortJump3']));
    else
      SJ.crowdSoundContainer.play(random(['crowdLongJump1', 'crowdLongJump2', 'crowdLongJump3']));


  }

  _checkOverRotate() {
    this.maxBodyAngle = Math.PI / 2;
    const angle = this.body.angle;

    if (angle < this.maxBodyAngle * -1) {
      this.setAngle(this.maxBodyAngle * -1);
    }
    else if (angle > this.maxBodyAngle) {
      this.setAngle(this.maxBodyAngle);
    }

    if (angle > -0.7 && angle < -0.1) this.c = color(0, 255, 0);
    else this.c = color(255, 0, 0);


    // if(this.body.angle < -0.55 || this.body.angle > 0.55){

    //   this.c = color(255, 0, 0);

    //   const padAngle = this.getPadAngle();

    //   const angle = this.getNormalizedBodyAngle();
    //   const diffAngle = degrees(angle - padAngle);

    //   this.overRotate = true;

    //   this._fail(diffAngle, false);

    //   this.body.velocity.y = lerp(this.body.velocity.y, 10, 0.5);
    //   this.body.velocity.x = lerp(this.body.velocity.x, 0.3, 0.05);
    // }
    // else {
    //   this.c = color(255);
    // }
  }

  testNormalizedAngle(enterAngle, exeptedAngle) {
    print(
      this.normalizeAngle(enterAngle) === exeptedAngle
        ? "OK"
        : "Test failed for:\nEA:" + enterAngle + "\nEA:" + exeptedAngle
    );
  }

  getNormalizedBodyAngle() {
    return this.normalizeAngle(this.body.angle);
  }

  normalizeAngle(angle) {
    while (angle > PI) {
      angle -= TWO_PI;
    }
    while (angle < -PI) {
      angle += TWO_PI;
    }

    return angle;
  }

  getPadAngle() {
    const diffX = SJ.pad._pullingSystem.p2.x - SJ.pad._pullingSystem.p1.x;
    const diffY = SJ.pad._pullingSystem.p2.y - SJ.pad._pullingSystem.p1.y;
    const padAngle = atan2(diffY, diffX);
    return padAngle;
  }

  draw() {
    const pos = this.body.position;
    const angle = this.body.angle;

    push();

    translate(pos.x, pos.y);

    // if(this.state === this.S.FLYING){
    //   push()
    //     fill(this.c);
    //     rect(-70, 10, 130, 3);
    //   pop();
    // }

    rotate(angle);

    // fill(255,255,255);
    // rectMode(CENTER);
    // rect(0, 0, this._w, 20);

    scale(this.scale);

    const offset = this.animationPlayer.currentAnimation.offset || new p5.Vector(0, 0);
    this.animationPlayer.draw(offset.x, offset.y);

    scale(1);

    // this.body.parts.forEach((part) => {
    //   beginShape();
    //   part.vertices.forEach((element) => {
    //     vertex(element.x, element.y);
    //   });
    //   endShape();
    // });

    pop();

    // push();
    //   fill(255, 255, 255, 64);
    //   this.body.parts.forEach((part) => {
    //     beginShape();
    //     part.vertices.forEach((element) => {
    //       vertex(element.x, element.y);
    //       // circle(element.x, element.y, 3);
    //     });
    //     endShape(CLOSE);
    //   });
    // pop();

    // this._drawVelocityVector();

    // console.log(this.body.position.x);
    // console.log(this.body.position.y);
    // console.log('=====');
  }

  _drawVelocityVector() {
    push();
    translate(this.body.position.x, this.body.position.y);
    scale(3.0);
    line(0, 0, this.body.velocity.x, this.body.velocity.y);
    pop();
  }

  onKeyPressed() {
    if (!this.failed) {
      if (keyCode == LEFT_ARROW || keyCode == UP_ARROW) {
        this.wantTurnTo(-1);
        if (
          this.state === this.S.FLYING &&
          this.flyState !== 4 &&
          !this.overRotate
        )
          this.animationPlayer.play("rotate-left");
      }
      else if (keyCode == RIGHT_ARROW || keyCode == DOWN_ARROW) {
        this.wantTurnTo(1);
        if (
          this.state === this.S.FLYING &&
          this.flyState !== 4 &&
          !this.overRotate
        )
          this.animationPlayer.play("rotate-right");
      }
      else if (keyCode == SPACE) {
        if (this.state == this.S.FLYING && this.canLand) {
          if (
            this.flyState == this.FLY_S.FLY ||
            this.flyState == this.FLY_S.FALLDOWN
          ) {
            this.land();
          }
        }
      }
    }
  }

  onKeyReleased() {
    if (keyCode == LEFT_ARROW || keyCode == RIGHT_ARROW || keyCode == UP_ARROW || keyCode == DOWN_ARROW) {
      this.wantTurn = false;
    }
  }

  controlWithJoystick() {
    if (SJ.ControlJoystick.position.y != 0 && SJ.ControlJoystick.position.x != 0) {
      if (SJ.IS_MOBILE)
        this.wantTurnTo(SJ.ControlJoystick.position.x);
      else
        this.wantTurnTo(SJ.ControlJoystick.position.y);
    }
  }

  onScreenTouchEnded() {
    // if ( this.flyState == this.FLY_S.FLY || this.flyState == this.FLY_S.FALLDOWN ) {
    //   this.land();
    // }
  }

  onScreenTouched() {
    if (SJ.IS_MOBILE) {
      if (this.state == this.S.FLYING && this.canLand) {
        if (
          this.flyState == this.FLY_S.FLY ||
          this.flyState == this.FLY_S.FALLDOWN
        ) {
          this.land();
        }
      }
    }
  }

  wantTurnTo(dir) {
    this.turningDir = dir;
    this.wantTurn = true;
    this.turningMod = 0.05;
  }

  land() {
    SJ.scoreCounter.landingHeight = SJ.scoreCounter.jumperHeight;
    this.animationPlayer.play("land");
    this.flyState = this.FLY_S.LANDING;
  }

  jump() {
    //Move jumper graphics
    this.animationPlayer.forEachAnimation((animation) => {
      animation.offset = new p5.Vector(-95, -160);
    });

    this.jumped = true;
    this.accelerateWithForce(SJ.V.jumperJumpForce + this.getJumpForceBonus());

    SJ.scoreCounter.jumperJumpPoint = this.body.position.x;
    SJ.scoreCounter.jumperJumpSpeed = SJ.jumperSpeed;

    this.animationPlayer.play("jump");
    this.flyState = this.FLY_S.JUMP;
    this.setAngle(-0.2);

  }

  accelerateWithForce(force) {
    const jumpAngle = this.body.angle;
    console.log(`Jump angle: ${jumpAngle}`);

    let jumpVector = Matter.Vector.create(force / 8, -force);
    jumpVector = Matter.Vector.rotate(jumpVector, jumpAngle);

    const newVelocity = Matter.Vector.add(this.body.velocity, jumpVector);
    Matter.Body.setVelocity(this.body, newVelocity);
  }

  getJumpForceBonus() {
    const diff = SJ.V.jumpEndPoint - this.body.position.x;
    const bonus = map(diff, 0, SJ.V.boostAreaWidth, SJ.V.maxJumpBoost, 0);
    console.log(`Jump force bonus: ${bonus}`);

    return bonus;
  }

  fly() {
    this.letSteering();
  }

  letSteering() {
    this.setStatic(false);
    this.state = this.S.FLYING;
  }

  setStatic(flag) {
    Matter.Body.setStatic(this.body, flag);
  }

  turn() {
    let deltaAngle = SJ.V.jumperTurnForce * this.turningMod * this.turningDir;
    let angle = this.body.angle + deltaAngle;
    this.setAngle(angle);
  }

  setAngle(angle) {
    Matter.Body.setAngle(this.body, angle);
  }
};
